module.exports = __webpack_public_path__ + "static/ogp-293c87584351fb30e8a7c5ef74550798.png";